(() => {
  const root = document.querySelector('[data-adawat-search]');
  if (!root) return;

  function getDrawer() {
    return document.querySelector('[data-collection-drawer]');
  }

  function fillDrawer() {
    const body = document.querySelector('[data-collection-drawer-body]');
    const side = document.querySelector('[data-collection-sidebar]');
    if (!body || !side || body.dataset.cloned === '1') return;
    body.innerHTML = side.innerHTML;
    body.dataset.cloned = '1';
  }

  function openDrawer() {
    const panel = getDrawer();
    if (!panel) return;
    if (panel.parentElement !== document.body) document.body.appendChild(panel);
    fillDrawer();
    panel.classList.add('is-open');
    document.documentElement.classList.add('adawat-collection-filters-open');
    if (typeof panel.showModal === 'function' && !panel.open) panel.showModal();
  }

  function closeDrawer() {
    const panel = getDrawer();
    if (!panel) return;
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('adawat-collection-filters-open');
    if (typeof panel.close === 'function' && panel.open) panel.close();
  }

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('[data-collection-filters-open]')) {
        event.preventDefault();
        openDrawer();
        return;
      }
      if (event.target.closest('[data-collection-filters-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.target.matches?.('[data-collection-drawer]')) closeDrawer();
    },
    true
  );

  const sortSelect = root.querySelector('[data-adawat-search-sort]');
  sortSelect?.addEventListener('change', () => {
    const url = new URL(window.location.href);
    const value = sortSelect.value;
    if (value) url.searchParams.set('sort_by', value);
    else url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  const viewButtons = root.querySelectorAll('[data-view-mode]');
  function setViewMode(mode) {
    const next = mode === 'list' ? 'list' : 'grid';
    root.classList.toggle('is-list-view', next === 'list');
    viewButtons.forEach((btn) => {
      const active = btn.getAttribute('data-view-mode') === next;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    try {
      sessionStorage.setItem('adawat-collection-view', next);
    } catch (e) {
      /* ignore */
    }
  }
  viewButtons.forEach((btn) => {
    btn.addEventListener('click', () => setViewMode(btn.getAttribute('data-view-mode')));
  });
  try {
    const savedView = sessionStorage.getItem('adawat-collection-view');
    if (savedView) setViewMode(savedView);
  } catch (e) {
    /* ignore */
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function productHref(el) {
    return el.querySelector('a[href*="/products/"]')?.getAttribute('href')?.split('?')[0] || '';
  }

  function updateSearchCount(count, query) {
    const countEl = root.querySelector('.adawat-collection__count');
    if (countEl) {
      countEl.textContent = count === 1 ? '1 product' : `${count} products`;
    }
    const subtitle = root.querySelector('[data-search-subtitle]');
    if (subtitle) {
      subtitle.innerHTML =
        count === 1
          ? `1 result for <span>“${escapeHtml(query)}”</span>`
          : `${count} results for <span>“${escapeHtml(query)}”</span>`;
    }
    const empty = root.querySelector('[data-search-empty]');
    if (empty) empty.hidden = count > 0;
  }

  function productMatchesQuery(product, query) {
    const q = String(query || '').toLowerCase();
    if (!q) return false;
    const title = String(product.title || '').toLowerCase();
    const handle = String(product.handle || '').toLowerCase().replace(/-/g, ' ');
    const vendor = String(product.vendor || '').toLowerCase();
    const type = String(product.product_type || product.type || '').toLowerCase();
    const tags = Array.isArray(product.tags) ? product.tags.join(' ').toLowerCase() : String(product.tags || '').toLowerCase();
    const sku = (product.variants || []).some((variant) => String(variant.sku || '').toLowerCase().includes(q));
    return title.includes(q) || handle.includes(q) || vendor.includes(q) || type.includes(q) || tags.includes(q) || sku;
  }

  async function expandContainsFromCatalogJson(query, existing, grid) {
    const catalogUrl = root.getAttribute('data-contains-url') || '/collections/all';
    let page = 1;
    let added = 0;
    while (page <= 20) {
      const res = await fetch(`${catalogUrl}/products.json?limit=250&page=${page}`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!res.ok) break;
      const data = await res.json();
      const products = Array.isArray(data.products) ? data.products : [];
      if (!products.length) break;
      const fragment = document.createDocumentFragment();
      products.forEach((product) => {
        if (!productMatchesQuery(product, query)) return;
        const href = `/products/${product.handle}`;
        if (existing.has(href)) return;
        existing.add(href);
        const image = product.images?.[0]?.src || '';
        const title = escapeHtml(product.title || '');
        const rawType = String(product.product_type || product.type || '').trim();
        const typeDown = rawType.toLowerCase();
        const typeGeneric =
          !rawType ||
          typeDown === 'all' ||
          typeDown === 'all products' ||
          typeDown.includes('all products') ||
          typeDown === 'frontpage' ||
          typeDown === 'home page' ||
          typeDown.includes('no discount') ||
          typeDown.includes('no-discount');
        const type = typeGeneric ? '' : escapeHtml(rawType.toUpperCase());
        const li = document.createElement('li');
        li.className = 'adawat-collection__grid-item';
        li.innerHTML = `
          <article class="adawat-product-card">
            <div class="adawat-product-card__media-wrap">
              <a href="${escapeHtml(href)}" class="adawat-product-card__media-link" aria-label="${title}">
                <div class="adawat-product-card__media" style="aspect-ratio: 1 / 1;">
                  ${
                    image
                      ? `<img class="adawat-product-card__image adawat-product-card__image--primary" src="${escapeHtml(image)}" alt="${title}" width="600" height="600" loading="lazy">`
                      : `<div class="adawat-product-card__placeholder" style="aspect-ratio: 1 / 1;"></div>`
                  }
                </div>
              </a>
            </div>
            <div class="adawat-product-card__info">
              ${type ? `<p class="adawat-product-card__type">${type}</p>` : ''}
              <h3 class="adawat-product-card__title"><a href="${escapeHtml(href)}">${title}</a></h3>
            </div>
          </article>
        `;
        fragment.appendChild(li);
        added += 1;
      });
      if (fragment.childNodes.length) grid.appendChild(fragment);
      if (products.length < 250) break;
      page += 1;
    }
    return added;
  }

  async function expandContainsMatches() {
    const grid = root.querySelector('[data-search-grid]');
    if (!grid) return;
    const query = (grid.dataset.searchQuery || new URLSearchParams(window.location.search).get('q') || '').trim();
    if (query.length < 2) return;

    const existing = new Set(
      [...grid.querySelectorAll('.adawat-collection__grid-item')].map((item) => productHref(item)).filter(Boolean)
    );

    let page = 1;
    let added = 0;
    try {
      while (page <= 20) {
        const params = new URLSearchParams({
          view: 'adawat-contains',
          contains: query,
          page: String(page),
        });
        const catalogUrl = root.getAttribute('data-contains-url') || '/collections/all';
        const res = await fetch(`${catalogUrl}?${params.toString()}`, {
          headers: { Accept: 'text/html' },
          credentials: 'same-origin',
        });
        if (!res.ok) break;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const meta = doc.querySelector('[data-contains-pages]');
        if (!meta && page === 1) {
          added += await expandContainsFromCatalogJson(query, existing, grid);
          break;
        }
        const totalPages = Math.max(1, Number(meta?.getAttribute('data-contains-pages')) || page);
        const fragment = document.createDocumentFragment();
        doc.querySelectorAll('[data-contains-hit]').forEach((item) => {
          const href = productHref(item);
          if (!href || existing.has(href)) return;
          existing.add(href);
          fragment.appendChild(document.importNode(item, true));
          added += 1;
        });
        if (fragment.childNodes.length) grid.appendChild(fragment);
        if (page >= totalPages) break;
        page += 1;
      }
    } catch (_) {
      /* keep Shopify results */
    }

    if (added) {
      window.adawatBindCardGalleries?.();
      window.AdawatWishlist?.sync?.();
    }
    updateSearchCount(grid.querySelectorAll('.adawat-collection__grid-item').length, query);
  }

  expandContainsMatches();

  // Infinite scroll (same pattern as collection pages)
  const grid = root.querySelector('[data-collection-grid]');
  const infiniteEl = root.querySelector('[data-collection-infinite]');
  const infiniteStatus = root.querySelector('[data-collection-infinite-status]');
  const infiniteLive = root.querySelector('[data-collection-infinite-live]');
  let infiniteLoading = false;
  let infiniteEnabled = Boolean(infiniteEl?.dataset.nextUrl);

  async function loadMoreSearchProducts() {
    if (!infiniteEnabled || infiniteLoading || !grid || !infiniteEl) return;
    const nextUrl = infiniteEl.dataset.nextUrl;
    if (!nextUrl) {
      infiniteEnabled = false;
      infiniteEl.hidden = true;
      return;
    }
    infiniteLoading = true;
    if (infiniteStatus) infiniteStatus.hidden = false;
    try {
      const res = await fetch(nextUrl, { headers: { Accept: 'text/html' }, credentials: 'same-origin' });
      if (!res.ok) throw new Error('Load failed');
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const nextGrid = doc.querySelector('[data-collection-grid]');
      const nextSentinel = doc.querySelector('[data-collection-infinite]');
      const existing = new Set(
        [...grid.querySelectorAll('.adawat-product-card a[href*="/products/"]')].map((a) => a.getAttribute('href')?.split('?')[0])
      );
      const fragment = document.createDocumentFragment();
      let added = 0;
      nextGrid?.querySelectorAll('.adawat-collection__grid-item').forEach((item) => {
        const href = item.querySelector('a[href*="/products/"]')?.getAttribute('href')?.split('?')[0];
        if (!href || existing.has(href)) return;
        existing.add(href);
        fragment.appendChild(document.importNode(item, true));
        added += 1;
      });
      if (added) {
        grid.appendChild(fragment);
        window.adawatBindCardGalleries?.();
        window.AdawatWishlist?.sync?.();
        if (infiniteLive) infiniteLive.textContent = `${added} more products loaded`;
        const q = grid.getAttribute('data-search-query') || '';
        updateSearchCount(grid.querySelectorAll('.adawat-collection__grid-item').length, q);
      }
      const following = nextSentinel?.getAttribute('data-next-url') || '';
      if (following) {
        infiniteEl.dataset.nextUrl = following;
      } else {
        infiniteEnabled = false;
        infiniteEl.hidden = true;
        delete infiniteEl.dataset.nextUrl;
      }
    } catch (error) {
      console.warn('[adawat-search] Infinite scroll failed:', error);
      infiniteEnabled = false;
      if (infiniteEl) infiniteEl.hidden = true;
    } finally {
      infiniteLoading = false;
      if (infiniteStatus) infiniteStatus.hidden = true;
    }
  }

  if (infiniteEl && infiniteEnabled) {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) loadMoreSearchProducts();
        },
        { rootMargin: '400px 0px' }
      );
      observer.observe(infiniteEl);
    } else {
      window.addEventListener(
        'scroll',
        () => {
          if (!infiniteEnabled || infiniteLoading) return;
          if (infiniteEl.getBoundingClientRect().top < window.innerHeight + 400) loadMoreSearchProducts();
        },
        { passive: true }
      );
    }
  }
})();
